<div class="date-field" [class.plain]="appearance === 'plain'" [class.disabled]="disabled" [class.open]="picker.isOpen()"
    (click)="!disabled && picker.toggle()">
    <i class="fal fa-calendar date-field-icon"></i>
    <span class="date-field-value" [class.is-placeholder]="!display">{{ display || placeholder }}</span>
    <i class="fal fa-xmark date-field-clear" *ngIf="display && !disabled" title="Quitar la fecha"
        (click)="clear($event)"></i>

    <!-- Input real: solo existe para que ng-bootstrap ancle y abra el
         calendario. Va oculto porque la fecha ya se pinta arriba. -->
    <input class="date-field-anchor" ngbDatepicker #picker="ngbDatepicker" datepickerClass="citylok-datepicker"
        [minDate]="minDate" [maxDate]="maxDate" [startDate]="startDate" [ngModel]="value"
        [ngModelOptions]="{ standalone: true }" (dateSelect)="onSelect($event)" [disabled]="disabled"
        navigation="select" outsideDays="hidden" container="body" placement="bottom-start top-start" tabindex="-1"
        readonly>
</div>
